import React, { FC, useEffect, useState } from 'react';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/bar';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import ReactEchartsCore from 'echarts-for-react/lib/core';

//访问量
export const FWL: FC<{ data: any }> = ({ data, ...props }) => {

	// useEffect(() => {
	// 	console.log(data)
	// }, [data])
	const option = {
		//提示框
		tooltip: {
			trigger: 'axis',
			axisPointer: {
				type: 'shadow'
			}
		},
		xAxis: {
			type: 'category',
			data: data.map((item: { userName: any; }) => item.userName),
			axisTick: { show: false },
			axisLabel: {
				show: true, // 是否显示刻度标签，默认显示
				interval: 0, // 坐标轴刻度标签的显示间隔，在类目轴中有效；默认会采用标签不重叠的策略间隔显示标签；可以设置成0强制显示所有标签；如果设置为1，表示『隔一个标签显示一个标签』，如果值为2，表示隔两个标签显示一个标签，以此类推。
				rotate: -60, // 刻度标签旋转的角度，在类目轴的类目标签显示不下的时候可以通过旋转防止标签之间重叠；旋转的角度从-90度到90度
				inside: false, // 刻度标签是否朝内，默认朝外
				margin: 6, // 刻度标签与轴线之间的距离
			},
		},
		yAxis: {
			type: 'value'
		},
		series: [
			{
				data: data.map((item: { visitNum: any; }) => item.visitNum),
				type: 'bar',
				barWidth: 14,    //主子宽度
				itemStyle: {
					borderRadius: [0, 0, 0, 0],
					opacity: 0.9,
					color: {
						type: 'linear',
						x: 1,
						y: 1,
						r: 1,
						colorStops: [{
							offset: 0, color: '#5B8FF9' // 0% 处的颜色
						}, {
							offset: 1, color: '#5B8FF9' // 100% 处的颜色
						}],
						globalCoord: false // 缺省为 false
					}
				},
			}
		]
	};

	return (
		<ReactEchartsCore
			className='wh100'
			echarts={echarts}
			theme="line"
			option={option as any}
		/>
	);
};

